// components/widgets/Stakeholders/PandaWave.jsx
import React from "react";
import pandaAvatar from "../../../../../assets/panda_stakeholders.png";

const PandaWave = () => {
  return (
    <div className="relative w-64 h-64 flex items-center justify-center">

      {/* --- Outer Waveform Ring (SVG) --- */}
      <svg
        width="260"
        height="260"
        viewBox="0 0 260 260"
        className="absolute inset-0"
      >
        <g transform="translate(130,130)">
          {Array.from({ length: 100 }).map((_, i) => {
            const angle = (i * 3.6) * (Math.PI / 180);
            const inner = 90;
            const outer = inner + (i % 2 === 0 ? 22 : 12);
            const x1 = inner * Math.cos(angle);
            const y1 = inner * Math.sin(angle);
            const x2 = outer * Math.cos(angle);
            const y2 = outer * Math.sin(angle);

            return (
              <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="#222"
                strokeWidth="3"
                strokeLinecap="round"
              />
            );
          })}
        </g>
      </svg>

      {/* --- Outer Thick White Ring --- */}
      <div className="absolute w-44 h-44 rounded-full border-[6px] border-white" />

      {/* --- Inner Dark Circle --- */}
      <div className="absolute w-40 h-40 rounded-full border-[3px] border-gray-700" />

      {/* --- Inner Teal Background --- */}
      <div className="absolute w-36 h-36 rounded-full bg-[#4EC4BF] flex items-center justify-center overflow-hidden">
        {/* Panda */}
        <img
          src={pandaAvatar}
          alt="Sto Panda"
          className="w-28 h-28 object-contain"
        />
      </div>
    </div>
  );
};

export default PandaWave;
